// Finding a bundle that is loaded on demand.
//
// Most of what the site does is in application.js, but two things are too big
// to hand to everyone for the sake of the few pages that use them: the code
// viewer (CodeMirror and its grammars) and the PDF reader (pdf.js). Each is its
// own esbuild entry point, fetched the first time something needs it.
//
// Propshaft digests filenames, so the URL cannot be written down here — the
// layout renders `asset_path` into a meta tag and this reads it back, the same
// way api.ts reads the CSRF token. Infrastructure the page was handed.

// One load per bundle per page, held as the promise rather than its result so
// that three callers arriving at once fetch once.
const pending = new Map<string, Promise<unknown>>()

export function loadBundle<T>(name: string): Promise<T> {
  const already = pending.get(name)
  if (already) return already as Promise<T>

  const source = document.querySelector<HTMLMetaElement>(`meta[name="bundle-${name}"]`)?.content
  if (!source) {
    return Promise.reject(new Error(`no bundle-${name} on this page`))
  }

  // The specifier is a variable on purpose: a literal would let esbuild resolve
  // it at build time and inline the whole bundle back into application.js,
  // which is the opposite of the point.
  const loading = import(source)
  pending.set(name, loading)
  return loading as Promise<T>
}
